import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import { HolidayPlanInfo, setHelperText } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { isSpaceInString } from "Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class NameAndDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      holidayplanname: "",
      description: "",
      holidayplanid: "",
      notUnique: false,
      ErName: false,
      CommonError: "",
      helperText: "",
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.OnNext,
    });
    this.props.ChangeLanguage("holidayplan");
    if (this.props.Language.holidayplan) {
      const text = this.props.Language.holidayplan.HtHolidayplanNameAndDesc;
      this.props.setHelperText({ helperText: text });
    }
    this.GetInfoFromLocalStorage();
    this.GetInfoFromLocalStorage();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(1, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  GetInfoFromLocalStorage() {
    const CurrentYear = new Date().getFullYear();
    this.props.StepError(1, false);
    const HolidayInfo = this.props.holidayPlanReducer;

    if (this.isEmpty(HolidayInfo)) {
      HolidayInfo.isdraft = true;
      this.props.AttendanceDevice({ ...HolidayInfo });
    } else {
      const holidayplanid = HolidayInfo.holidayplanid
        ? HolidayInfo.holidayplanid
        : 0;
      const holidayyear = HolidayInfo.holidayyear
        ? HolidayInfo.holidayyear
        : CurrentYear;
      const { holidayplanname } = HolidayInfo;
      const { description } = HolidayInfo;
      const isdraft = HolidayInfo.isdraft != false;
      this.setState({
        holidayplanid,
        holidayplanname,
        description,
        holidayyear,
        isdraft,
      });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  OnNameChange(e) {
    this.setState({ holidayplanname: e.target.value });
  }

  OnDescriptionChange(e) {
    this.setState({ description: e.target.value }, () => {
      this.UpdateHolidayPlanInfoReducer();
    });
  }

  checkUnique(goNext = false) {
    if (this.state.holidayplanname) {
      const URL = "/leaves/checkuniqueholidayplanname";
      const data = {
        holidayplanname: this.state.holidayplanname,
        holidayplanid: this.state.holidayplanid
          ? this.state.holidayplanid
          : null,
      };
      instance
        .post(URL, data)
        .then((result) => {
          if (result.data.result[0].isunique == true) {
            this.setState({ notUnique: false, ErName: false }, () => {
              this.props.StepError(1, false);
              this.UpdateHolidayPlanInfoReducer();
              if (goNext === true) this.props.click();
            });
          } else if (result.data.result[0].isunique == false) {
            this.setState({ notUnique: true, ErName: false }, () => {
              this.props.StepError(1, true);
            });
          }
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.setState({ notUnique: true, ErName: false, CommonError }, () => {
            this.props.StepError(1, true);
          });
        });
    } else {
      this.setState({ notUnique: false, ErName: true }, () => {
        this.props.StepError(1, true);
      });
    }
  }

  UpdateHolidayPlanInfoReducer() {
    const CurrentYear = new Date().getFullYear();
    const HolidayInfo = this.props.holidayPlanReducer;
    HolidayInfo.holidayplanid = this.state.holidayplanid
      ? this.state.holidayplanid
      : null;
    HolidayInfo.holidayplanname = this.state.holidayplanname;
    HolidayInfo.description = this.state.description;
    HolidayInfo.holidayyear = HolidayInfo.holidayyear
      ? HolidayInfo.holidayyear
      : CurrentYear;
    HolidayInfo.isdraft = this.state.isdraft;
    this.props.HolidayPlanInfo({ ...HolidayInfo });
  }

  OnNext = () => {
    if (this.state.holidayplanname && !isSpaceInString(this.state.holidayplanname)) {
      this.state.holidayplanname = this.state.holidayplanname.trim();
    }
    this.checkUnique(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.holidayplan[${HtField}]`, "");
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;

    const language = this.props.Language.holidayplan;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <div className="stepper-scroller padding-top-0">
            <div className="stepper-scroller-content">
              <div className="device-wrapper">
                <p className="add-label-active">
                  <FormattedMessage
                    id="LbHolidayplanname"
                    defaultMessage="Holiday Plan Name"
                  />
                </p>
                {/* <input type="text" className="form-control"
                                        autoComplete="off"
                                        autoFocus placeholder="Holiday Plan Name"
                                        onFocus={this.HelperSliderFlag.bind(this, "Htholidayplanname")}
                                        onChange={this.OnNameChange.bind(this)}
                                        onBlur={this.checkUnique.bind(this)}
                                        value={this.state.holidayplanname}
                                        maxLength="50" /> */}
                <TextField
                  id="outlined-dense"
                  margin="dense"
                  variant="outlined"
                  autoComplete="off"
                  style={{ width: "100%" }}
                  placeholder="Enter holiday plan name"
                  onFocus={this.HelperSliderFlag.bind(
                    this,
                    "Htholidayplanname",
                  )}
                  onChange={this.OnNameChange.bind(this)}
                  onBlur={this.checkUnique.bind(this)}
                  value={this.state.holidayplanname}
                  maxLength="100"
                  className="form-text-input"
                  autoFocus
                />
                <div>
                  {this.state.ErName == true ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErName"
                        defaultMessage="name can not be empty"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                  {this.state.notUnique == true ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErAlreadyExists"
                        defaultMessage="Holiday Plan Name Already Exists"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="device-wrapper">
                <p className="add-label-active">
                  <FormattedMessage
                    id="LbAddDescription1"
                    defaultMessage="Add a description to help your colleagues get extra info about this holiday plan"
                  />
                </p>
                {/* <textarea
                  className="input-area-section"
                  placeholder="Description"
                  onFocus={this.HelperSliderFlag.bind(this, "HtDescription")}
                  onChange={this.OnDescriptionChange.bind(this)}
                  value={this.state.description}
                  maxLength="200"
                /> */}
                <TextArea
                  className="width100"
                  maxLength="200"
                  variant="outlined"
                  placeholder="Description "
                  multiline
                  onFocus={this.HelperSliderFlag.bind(this, "HtDescription")}
                  onChange={this.OnDescriptionChange.bind(this)}
                  value={this.state.description}
                />
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

NameAndDescription.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      HolidayPlanInfo: (data) => HolidayPlanInfo(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(NameAndDescription)));
